import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import toastHandler from 'Utils/toastHandler';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { IObraInvitedUsersDeleteRequest } from 'Data/interfaces/Obra/IObraUsers';
import { IInvitedUser } from 'Data/interfaces/User/IInvitedUser';

export const useQueryDisinviteUsersObra = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IObraInvitedUsersDeleteRequest) => {
      return ObrasApiV2.deleteInvitedUsers(variables);
    },
    onMutate: async (variables) => {
      const previousObras = queryClient.getQueryData<IObraResponse[]>(
        [OBRA_QUERY_KEY],
      );
      const previousUniqueObra = queryClient.getQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.constructionStieId)],
      );

      queryClient.setQueryData<IObraResponse[]>([OBRA_QUERY_KEY], (
        oldData,
      ) => {
        return oldData?.map((obra) => {
          if (obra.ConstructionSiteId === variables.constructionStieId) {
            return {
              ...obra,
              InvitedUsers: obra.InvitedUsers?.filter((user: IInvitedUser) => {
                return user.Email !== variables.invitedEmail;
              }),
            };
          }
          return obra;
        });
      });
      queryClient.setQueryData<IObraResponse>([OBRA_QUERY_KEY, Number(variables.constructionStieId)], (
        oldData,
      ) => {
        if (oldData && oldData.ConstructionSiteId === variables.constructionStieId) {
          return {
            ...oldData,
            InvitedUsers: oldData.InvitedUsers?.filter((user: IInvitedUser) => {
              return user.Email !== variables.invitedEmail;
            }),
          };
        }
        return oldData;
      });

      return { previousObras, previousUniqueObra };
    },
    onSuccess: () => {
      toastHandler.showSuccess('Compartilhamento removido com sucesso!');
    },
    onError: async (error: any, variables, context) => {
      await Promise.all([
        queryClient.cancelQueries({ queryKey: [OBRA_QUERY_KEY] }),
        queryClient.cancelQueries({
          queryKey: [OBRA_QUERY_KEY, Number(variables.constructionStieId)],
        }),
      ]);

      queryClient.setQueryData([OBRA_QUERY_KEY], context?.previousObras);
      queryClient.setQueryData(
        [OBRA_QUERY_KEY, Number(variables.constructionStieId)],
        context?.previousUniqueObra,
      );

      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao remover compartilhamento!';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    disinviteUsersObra: mutate,
    isLoading: isPending,
  };
};
